import { render, staticRenderFns } from "./Create_Saler.vue?vue&type=template&id=9dae1f50"
import script from "./Create_Saler.vue?vue&type=script&lang=js"
export * from "./Create_Saler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports